/**
 * DTX — lazy-loads section scripts when their markup enters the viewport.
 */
(function () {
  const manifestEl = document.getElementById('dtx-script-manifest');
  if (!manifestEl) return;

  let manifest;
  try {
    manifest = JSON.parse(manifestEl.textContent || '{}');
  } catch {
    return;
  }

  const loaded = new Set();

  function loadScript(url) {
    if (!url || loaded.has(url)) return Promise.resolve();
    loaded.add(url);

    return new Promise((resolve, reject) => {
      const script = document.createElement('script');
      script.src = url;
      script.defer = true;
      script.onload = () => resolve();
      script.onerror = () => reject(new Error(`DTX: failed to load ${url}`));
      document.body.appendChild(script);
    });
  }

  function observeEntry(entry) {
    const { selector, url, eager } = entry;
    if (!selector || !url) return;

    const nodes = document.querySelectorAll(selector);
    if (!nodes.length) return;

    const run = () => loadScript(url).catch(() => {});

    if (eager) {
      run();
      return;
    }

    if (!('IntersectionObserver' in window)) {
      run();
      return;
    }

    const observer = new IntersectionObserver(
      (records) => {
        if (!records.some((record) => record.isIntersecting)) return;
        observer.disconnect();
        run();
      },
      { rootMargin: '120px 0px', threshold: 0.01 }
    );

    nodes.forEach((node) => observer.observe(node));
  }

  function boot() {
    if (!Array.isArray(manifest.entries)) return;
    manifest.entries.forEach(observeEntry);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot, { once: true });
  } else {
    boot();
  }
})();
